import { DataLayerMeta, DataLayerEvent } from './types'
import { getDataLayer } from './get-data-layer'

export const dataLayerPublish = <Meta>(key: DataLayerEvent, meta: DataLayerMeta<Meta> = {}) => {
  const dataLayer = getDataLayer()
  if (!dataLayer) {
    return
  }

  try {
    dataLayer.publish(key, meta)
  } catch {
    //
  }
}

export const dataLayerUpdate = <Data, Meta>(data: Data) => {
  const dataLayer = getDataLayer<Data, Meta>()
  if (!dataLayer) {
    return
  }

  // analytics is an extra layer and should never interfere with our application when in error
  try {
    dataLayer.update({
      ...dataLayer.data,
      ...data,
    })
    // eslint-disable-next-line no-empty
  } catch {
    //
  }
}

export const dataLayerSetPage = <Data, Meta>(pageMeta: Meta) => {
  const dataLayer = getDataLayer<Data, Meta>()
  if (!dataLayer) {
    return
  }

  try {
    dataLayer.update({
      ...dataLayer.data,
      ...pageMeta,
      timestamp: Date.now(),
    })

    setTimeout(() => {
      dataLayer.publish('PAGE_LOAD', pageMeta)
    }, 0)
    // eslint-disable-next-line no-empty
  } catch {
    //
  }
}

export const dataLayerReset = () => {
  const dataLayer = getDataLayer()
  if (!dataLayer) {
    return
  }

  // analytics is an extra layer and should never interfere with our application when in error
  try {
    dataLayer.reset()
    // eslint-disable-next-line no-empty
  } catch {
    //
  }
}
